<script setup>
  import {ref, onMounted, computed} from 'vue';
  import { useRouter } from 'vue-router';
  const navRoutes = ref([]);
  const router = useRouter();
  onMounted(() => {
    const allRoutes = router.getRoutes();
    allRoutes.forEach(route => {
      if (route.meta?.showInMenu) {
        navRoutes.value.push({
          'path': route.path,
          'title': route.meta.title,
          'icon': route.meta.icon || 'bi bi-circle'
        });
      }
    });
  });

</script>

<template>
  <ul  class="nav flex-column w-100">
    <li  class="nav-item mb-2" v-for="route in navRoutes">
      <router-link class="nav-link d-flex align-items-center" :to="route.path">
        <i class="bi me-2" :class="route.icon"></i> {{route.title}}
      </router-link>
    </li>
  </ul>
</template>

<style scoped lang="scss">
.nav-link {
  font-weight: bold;
  color: #034c48;

  &:hover {
    color: #42b983;
  }

  &.router-link-active {
    color: #42b983;
  }
}
</style>
